import React, { useRef } from 'react';
import { useHistory } from 'react-router';
import { MenuCategoryData } from '../../../interface';
import {
	RBHBox,
	RBHButton,
	RBHText,
	RBHTextInput,
	TagCount,
} from '../../../../../../shared/components';
import styles from './styles';

import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { CAT_STATE_KEY, catStateSelector } from '../../../redux/cat-reducer';
import { generalCreators } from '../../../../../../redux/general/general-action';
import { GENERAL_STATE_KEY } from '../../../../../../redux/general/general-reducer';
import { MODAL_TYPE } from '../../../../../../redux/general/general-constant';
import { RBHList } from '../../../../../../shared/components/rbh-list';
import { catCreators } from '../../../redux/cat-action';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { CAT_REQUEST_ID_LIST } from '../../../redux/cat-constant';
import { catSagas } from '../../../redux/cat-saga';
import { CatService } from '../../../redux/cat-service';
import { SortButton } from '../../../../components/SortButton';

interface TabHeaderProps {
	search: string | null;
	onSearchChange: (value: string) => void;
	onSortedSuccess: () => void;
}
export const TabHeader = ({
	search,
	onSearchChange,
	onSortedSuccess,
}: TabHeaderProps) => {
	const dispatch = useDispatch();
	const data = useSelector(
		catStateSelector(CAT_STATE_KEY.FULL_LIST),
	) as MenuCategoryData[];
	const categoryCount = useSelector(
		catStateSelector(CAT_STATE_KEY.CAT_COUNT),
	) as number | undefined;
	const sortedItemRef = useRef<{ id: number }[]>([]);

	const getSortableItems = (items: MenuCategoryData[]) =>
		items
			.filter((item) => item.menuCategoryName !== 'โปรโมชัน')
			.map((item) => ({
				id: item.menuCategoryId,
				name: item.menuCategoryName,
			}));

	const handleSort = (items: { id: number }[]) => {
		sortedItemRef.current = items;
	};

	const openSortFormModal = () => {
		if (data) {
			openModal(data);
			return;
		}
		const onSuccessCallback = (data: MenuCategoryData[]) => {
			openModal(data);
		};
		dispatch(catCreators.callFullFoodCategory(onSuccessCallback));
	};

	const openModal = (data?: MenuCategoryData[]) => {
		const sortableItems = getSortableItems(data ?? []);
		sortedItemRef.current = sortableItems;

		const handleSubmit = () => {
			dispatch(
				generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
					visible: false,
				}),
			);
			dispatch(
				httpCreators.request({
					id: CAT_REQUEST_ID_LIST.UPDATE_CATEGORY_SEQUENCE,
					sagaHandler: catSagas.updateCategorySequenceHandler,
					callbackParams: onSortedSuccess,
					service: CatService.updateCategorySequence,
					serviceParams: sortedItemRef.current.map((item) => item.id),
				}),
			);
		};

		dispatch(
			generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
				visible: true,
				type: MODAL_TYPE.LIST_SORT_FORM,
				modalTitle: 'main.cat_category.sort_modal.title',
				modalContent: (
					<RBHList
						dataSource={sortableItems}
						renderItem={(item) => {
							return <span>{item.name}</span>;
						}}
						dragable
						onSort={handleSort}
					/>
				),
				onCancel: () => {
					dispatch(
						generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, {
							visible: false,
						}),
					);
				},
				onOk: handleSubmit,
			}),
		);
	};
	return (
		<RBHBox style={styles.header}>
			<RBHBox style={styles.titleSection}>
				<RBHText
					style={styles.headerText}
					text={'main.cat_category.category_tab.header'}
					id={'cat_category_tab_header'}
				/>
				<TagCount
					id='cat_category_tag_count'
					count={categoryCount ?? 0}
					size='lg'
				/>
				<RBHTextInput
					prefix={<SearchOutlined style={styles.searchIcon} translate={null} />}
					placeholder='main.cat_category.search.placeholder'
					id={'search-menuCategory-input'}
					style={styles.search}
					value={search}
					onChange={(e: any) => {
						onSearchChange(e.target.value);
					}}
				/>
			</RBHBox>
			<RBHBox style={styles.ActionSection}>
				<SortButton
					disable={!categoryCount || categoryCount < 2}
					textId='main.cat_category.category_tab.sorting'
					onClick={openSortFormModal}
				/>
				<RBHBox style={styles.addAndSearchSection}>
					<AddButton />
				</RBHBox>
			</RBHBox>
		</RBHBox>
	);
};

const AddButton = () => {
	const history = useHistory();

	const toAddCat = () => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
		history.push('/main/addfoodcategory');
	};

	const toAddMenu = () => {
		history.push('/main/addMenu');
	};

	return (
		<>
			<RBHButton
				id={'cat_addcat'}
				style={styles.buttonAdd}
				text={'main.cat_addcat'}
				type='primary'
				onClick={toAddCat}
				icon={<PlusOutlined translate={null} />}
			></RBHButton>
			<RBHButton
				id={'cat_addmenu'}
				style={styles.buttonAdd}
				text={'main.cat_addmenu'}
				type='primary'
				onClick={toAddMenu}
				icon={<PlusOutlined translate={null} />}
			></RBHButton>
		</>
	);
};
